import { Injectable } from '@angular/core';
import { ComponentStore, OnStoreInit, tapResponse } from '@ngrx/component-store';
import { Bank, BusinessField } from '../../../models';
import { DictionariesService } from '../../../http';
import { switchMap } from 'rxjs/operators';

export interface PdBankDataState {
  banks?: Bank[];
  businessFields?: BusinessField[];
}

@Injectable()
export class PdBankDataStore extends ComponentStore<PdBankDataState> implements OnStoreInit {
  public banks$ = this.select((state) => state.banks);
  public businessFields$ = this.select((state) => state.businessFields);

  constructor(private readonly dictionariesService: DictionariesService) {
    super({});
  }

  public ngrxOnStoreInit(): void {
    this.getBanks();
    this.getBusinessFields();
  }

  private getBanks = this.effect((trigger$) => {
    return trigger$.pipe(
      switchMap(() => this.dictionariesService.getBanks()),
      tapResponse(
        (banks) => {
          this.patchState({ banks });
        },
        (error) => {
          // TODO: handle error
          console.error(error);
        },
      ),
    );
  });

  private getBusinessFields = this.effect((trigger$) => {
    return trigger$.pipe(
      switchMap(() => this.dictionariesService.getBusinessFields()),
      tapResponse(
        (businessFields) => {
          this.patchState({ businessFields });
        },
        (error) => {
          // TODO: handle error
          console.error(error);
        },
      ),
    );
  });
}
